import { render } from "./PenangkapGalat.vue?vue&type=template&id=1d9f7960&scoped=true"
import script from "./PenangkapGalat.vue?vue&type=script&lang=js"
export * from "./PenangkapGalat.vue?vue&type=script&lang=js"

import "./PenangkapGalat.vue?vue&type=style&index=0&id=1d9f7960&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d9f7960"]])

export default __exports__